import FileView from '../views/mainViews/FileView';
import FileDocumentView from '../views/mainViews/FileDocumentView';
import PageNotFound from '../views/mainViews/PageNotFound';
import SignedView from '../views/mainViews/SignedView';

export const GeneralPaths = {
	filesView: {
		id: 'file',
		name: 'Files',
		path: '/files/:orgId/:fileId',
		view: FileView,
		props: {
			default: (route) => ({
				orgId: route.params.orgId,
				userId: route.query.userId,
				fileId: route.params.fileId,
			}),
		},
	},
	fileDocView: {
		id: 'fileViewer',
		name: 'Files',
		path: '/files/:orgId',
		view: FileDocumentView,
		props: {
			default: (route) => ({
				orgId: route.params.orgId,
				documentLink: route.query.documentLink,
			}),
		},
	},
	signedView: {
		id: 'signed',
		name: 'Signed Document',
		path: '/files/signedDocument/:orgId/:fileId',
		view: SignedView,
		props: {
			default: (route) => ({
				orgData: route.params.orgId,
				userId: route.params.userId,
				fileData: route.params.fileId,
				documentLink: route.params.documentLink,
			}),
		},
	},
	notFound: {
		id: 'notFound',
		name: 'Page Not Found',
		path: '*',
		view: PageNotFound,
	},
};
